import { useEffect } from 'react';

/**
 * Hook to disable body scroll when in fullscreen mode
 */
export const useFullscreenBodyScroll = (isFullscreen: boolean) => {
  useEffect(() => {
    if (isFullscreen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isFullscreen]);
};
